import { versionCompare } from '@sophocles/utils/utils';

const magicVersionNumber = '20.1.0';

export const REV = {
  A: 'REV_A',
  B: 'REV_B',
};

export const getRevVersion = ({ statusMap, selectedStructure, unitId }) => {
  if (statusMap && (selectedStructure || unitId)) {
    const unit = unitId || selectedStructure.getIn(['relay_controller', 'id'], '0');
    const status = statusMap.get(unit.toString(), {});
    const version = status && status.version ? status.version : statusMap.get('version', '');
    const showRevB = versionCompare(version, magicVersionNumber) + 1; // will return zero if equal so +1 makes this a positive bool
    return showRevB ? REV.B : REV.A;
  }

  return false;
};
